import * as React from "react";
import classnames from "classnames";
import { MediaQuery, Carousel } from "@grandvisionhq/common";
/* empty css                     */
import { VariantSwitcherItem } from "../components/VariantSwitcherItem/VariantSwitcher/components/VariantSwitcherItem/VariantSwitcherItem.js";
const calculateInitialIndex = (variants, activeSku, itemsPerSlide) => {
  const activeIndex = variants.findIndex((variant) => variant.sku === activeSku);
  if (activeIndex === -1) {
    return 0;
  }
  return Math.floor(activeIndex / itemsPerSlide);
};
const VariantSwitcher = ({
  variants,
  activeSku,
  onVariantChange,
  className,
  tabIndex
}) => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  const itemsPerSlide = MediaQuery.useIsPhone() ? 2 : 3;
  const initialIndex = React.useMemo(
    () => calculateInitialIndex(variants, activeSku, itemsPerSlide),
    [variants, activeSku, itemsPerSlide]
  );
  const carouselItems = React.useMemo(() => {
    const max = Math.ceil(variants.length / itemsPerSlide);
    const items = [];
    for (let i = 0; i < max; i++) {
      const start = i * itemsPerSlide;
      const end = (i + 1) * itemsPerSlide;
      items.push(
        /* @__PURE__ */ React.createElement(
          "div",
          {
            key: `variant-switcher-${i}`,
            className: classnames("variant-switcher__slide", {
              "variant-switcher__slide--single": max === 1
            })
          },
          variants.slice(start, end).map(({ sku, images }) => /* @__PURE__ */ React.createElement(
            VariantSwitcherItem,
            {
              key: sku,
              image: images?.[0],
              sku,
              isActive: sku === activeSku,
              onClick: onVariantChange,
              hasDisabledTabIndex: tabIndex === -1 || activeIndex !== i
            }
          ))
        )
      );
    }
    return items;
  }, [variants, itemsPerSlide, activeSku, onVariantChange, tabIndex, activeIndex]);
  if (variants.length <= 1) {
    return null;
  }
  return /* @__PURE__ */ React.createElement("div", { className: classnames("variant-switcher", className) }, /* @__PURE__ */ React.createElement(
    Carousel,
    {
      onIndexChange: setActiveIndex,
      shouldLoopNavigationFocus: true,
      initialIndex
    },
    carouselItems
  ));
};
export {
  VariantSwitcher,
  calculateInitialIndex
};
//# sourceMappingURL=VariantSwitcher.js.map
